<template>
  <div class="postavitev-info">
    <div>
      <div class="info-okvir">
        <div class="postavitev-info-icone">
          <i class="fa fa-info-circle"></i>
        </div>
        <div class="postavitev-info-tekst">
          <p class="modra-barva-info">
            Ob prejemu računov v spletno banko prejemanje računov po elektronski ali navadni pošti ni možno.
            Račune si lahko vedno pogledate v zavihku
            <a href="/MojT2/Racuni" class="modra-barva-info" style="text-decoration: underline;">
              Računi</a>.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'InfoKomponentaPrejemanjeRacunovEbanka'
  }
</script>

<style scoped>
.info-okvir {
  width: 580px;
  height: 85px;
  display: flex;
}

@media only screen and (max-width: 1100px) {
  .info-okvir {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/Eposlovanje/InfoKomponentaPrejemanjeRacunovEbanka.vue